// extracted by mini-css-extract-plugin
export default {"icon-button-wrapper":"_19YN0","iconButtonWrapper":"_19YN0","number":"_2MBiJ"};